<template>
  <!-- Kontener filtrowania zakresowego: elastyczny układ w wierszu -->
  <div class="filter d-flex">
    <!-- Etykieta (nazwa) pola, pochodzi z props name -->
    <div class="name">{{ name }}</div>
    <!-- Symbol oznaczający początek zakresu (np. "od") -->
    <span class="symbol">{{ symbolFrom }}</span>
    <!-- Pole input dla wartości początkowej zakresu -->
    <input
      :name="fieldFromName"
      v-model.lazy="valueFrom"
      type="number"
      @wheel.prevent
      @touchmove.prevent
      @scroll.prevent
    />
    <!-- Symbol oznaczający koniec zakresu (np. "do") -->
    <span class="symbol">{{ symbolTo }}</span>
    <!-- Pole input dla wartości końcowej zakresu -->
    <input
      :name="fieldToName"
      v-model.lazy="valueTo"
      type="number"
    />
  </div>
</template>

<script>
import { watch, ref } from "vue";                             // Import funkcji reaktywnych
import { useArchivalFiltersStore } from "../../stores/archivalFilters"; // Store Pinia dla filtrów archiwalnych

export default {
  name: "RangeFilter",                                       // Nazwa komponentu
  props: ["name", "symbolFrom", "fieldFromName", "symbolTo", "fieldToName"],
  
  setup(props) {
    // Inicjalizacja store'a z filtrami
    const filtersStore = useArchivalFiltersStore();

    // Ustawienie początkowych wartości pola od i do na podstawie store'a
    const valueFrom = ref(
      filtersStore.filters[props.fieldFromName] ?? ""
    );
    const valueTo = ref(
      filtersStore.filters[props.fieldToName] ?? ""
    );

    // Funkcja zapisująca zmiany w store: nazwa pola i wartość
    const saveValue = (fieldName, newVal) => {
      filtersStore.addItem(fieldName, newVal);
    };

    // Obserwator zmian obu wartości: valueFrom i valueTo
    watch(
      [valueFrom, valueTo],
      ([newFrom, newTo], [oldFrom, oldTo]) => {
        // Jeśli zmieniła się wartość początkowa, zapisujemy ją
        if (newFrom !== oldFrom) {
          saveValue(props.fieldFromName, newFrom);
        }
        // Jeśli zmieniła się wartość końcowa, zapisujemy ją
        if (newTo !== oldTo) {
          saveValue(props.fieldToName, newTo);
        }
      }
    );

    // Zwracamy referencje do template
    return { valueFrom, valueTo, filtersStore };
  }
};
</script>

<style scoped>
/* Usunięcie strzałek w polach number dla WebKit */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Podstawowy styl kontenera filtra */
.filter {
  border-bottom: 1px solid #b7b7b5;
  padding-bottom: 5px;
  margin-top: 5px;
}
/* Usunięcie dolnej ramki dla ostatniego filtra */
.filter:last-child {
  border: none;
}
/* Styl pól input */
input {
  width: 50px;
  padding: 2px 7px;
  text-align: center;  /* Wyśrodkowanie tekstu liczbowego */
}
/* Odstęp wokół symboli od/do */
.symbol {
  padding: 5px;
}
</style>
